import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { useTheme } from '../../contexts/ThemeContext';

const OnBoarding: React.FC = () => {
    const navigate = useNavigate();
    const swiperRef = useRef<SwiperType | null>(null);
    const userPhotoInputRef = useRef<HTMLInputElement>(null);
    const companyLogoInputRef = useRef<HTMLInputElement>(null);
    const [selectedDomain, setSelectedDomain] = useState<string>('finance');
    const [selectedTheme, setSelectedTheme] = useState<string>('theme-blue');
    const [isLastSlide, setIsLastSlide] = useState<boolean>(false);
    const { setColorTheme } = useTheme();

    const handleSelectableClick = (groupSetter: (value: string) => void, value: string) => {
        groupSetter(value);

        // If it's a theme selection, also apply it globally
        if (value.startsWith('theme-')) {
            const colorName = value.replace('theme-', '');
            setColorTheme(colorName as any);
        }
    };


    return (
        <>
            <div className="col-12 col-md-11 col-lg-10 col-xl-8 col-xxl-7">
                <div className="row gx-3 gx-lg-4 h-100 py-3 px-md-3 align-items-center">
                    <div className="col-12">
                        <div className="row gx-3 mb-4 mb-lg-5">
                            <div className="col align-self-center">
                                <h5>User Onboarding</h5>
                            </div>
                            <div className="col-auto">
                            </div>
                        </div>

                        {/* content swiper */}
                        <Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={0}
                            slidesPerView={1}
                            navigation={{
                                nextEl: '.btn-next',
                                prevEl: '.btn-prev',
                            }}
                            pagination={{
                                el: '.swiper-pagi',
                                clickable: true,
                                type: 'bullets',
                            }}
                            allowTouchMove={false}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            onSlideChange={(swiper) => {
                                setIsLastSlide(swiper.isEnd);
                            }}
                            onReachEnd={() => {
                                setIsLastSlide(true);
                            }}
                            className="h-100 w-100"
                        >
                            <SwiperSlide>
                                <h4>Do you want to upload your profile pic and reveal Name?</h4>
                                <p className="text-secondary mb-3 mb-lg-4">Please share your <b>Photo</b> and <b>Name</b> to display in application. This will be logged in user name wherever mentioned. This is just to make more intuitive communication with interface.</p>

                                <div className="row gx-3">
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-1.jpg')} alt="" id="journeyuserpic1" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-9.jpg')} alt="" id="journeyuserpic2" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-3.jpg')} alt="" id="journeyuserpic3" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-7.jpg')} alt="" id="journeyuserpic4" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-5.jpg')} alt="" id="journeyuserpic5" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div className="avatar avatar-60 coverimg rounded-circle">
                                            <img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" id="journeyuserpic6" />
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-lg-4">
                                        <div>
                                            <div className="avatar avatar-60 coverimg rounded-circle" style={{ backgroundImage: `url("assets/img/adminuiux/user-8.jpg")` }}>
                                                <input ref={userPhotoInputRef} type="file" accept="image/*" id="userphotoonboarding" className="position-absolute h-100 w-100 opacity-0 z-index-1" />
                                                <i className="bi bi-upload bg-theme-1 fs-5 avatar avatar-40 width-40 rounded-circle z-index-1" onClick={() => userPhotoInputRef.current?.click()}></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <form className="mb-3 mb-lg-4">
                                    {/* Form elements */}
                                    <div className="form-group mb-2 position-relative check-valid is-valid width-300">
                                        <div className="input-group input-group-lg">
                                            <span className="input-group-text text-theme-1"><i className="bi bi-person-circle"></i></span>
                                            <div className="form-floating">
                                                <input type="text" placeholder="Username" defaultValue="DevUIUX" required className="form-control" autoFocus={true} id="usernamevalue" />
                                                <label htmlFor="usernamevalue">Your good name</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </SwiperSlide>
                            <SwiperSlide>
                                <h4>What's your<br />Industries or Business Domain?</h4>
                                <p className="text-secondary mb-3 mb-lg-4">Selection of Industry or Business domain helps us to choose demo layout or formatting you would like as most of the preferences and based on market standard practices.</p>
                                <div className="row gx-3" id="domain-select">
                                    <div className="col-4 col-lg-3 col-xl">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-3 ${selectedDomain === 'finance' ? 'active' : ''}`} data-title="finance" onClick={() => handleSelectableClick(setSelectedDomain, 'finance')}>
                                            <div className="card-body">
                                                <div className="avatar avatar-40 text-theme-1 fs-5 mb-2 rounded-circle">
                                                    <i className="bi bi-coin"></i>
                                                </div>
                                                <p className="small text-secondary text-truncated">Finance</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-lg-3 col-xl">
                                        <div className={`card adminuiux-card text-center selectable anyone mb-3 ${selectedDomain === 'network' ? 'active' : ''}`} data-title="network" onClick={() => handleSelectableClick(setSelectedDomain, 'network')}>
                                            <div className="card-body">
                                                <div className="avatar avatar-40 text-theme-1 fs-5 mb-2 rounded-circle">
                                                    <i className="bi bi-wifi"></i>
                                                </div>
                                                <p className="small text-secondary text-truncated">Network</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-lg-3 col-xl">
                                        <div className={`card adminuiux-card text-center selectable anyone mb-3 ${selectedDomain === 'social' ? 'active' : ''}`} data-title="social" onClick={() => handleSelectableClick(setSelectedDomain, 'social')}>
                                            <div className="card-body">
                                                <div className="avatar avatar-40 text-theme-1 fs-5 mb-2 rounded-circle">
                                                    <i className="bi bi-people"></i>
                                                </div>
                                                <p className="small text-secondary text-truncated">Social</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-lg-3 col-xl">
                                        <div className={`card adminuiux-card text-center selectable anyone mb-3 ${selectedDomain === 'inventory' ? 'active' : ''}`} data-title="inventory" onClick={() => handleSelectableClick(setSelectedDomain, 'inventory')}>
                                            <div className="card-body">
                                                <div className="avatar avatar-40 text-theme-1 fs-5 mb-2 rounded-circle">
                                                    <i className="bi bi-basket"></i>
                                                </div>
                                                <p className="small text-secondary text-truncated">Inventory</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-4 col-lg-3 col-xl">
                                        <div className={`card adminuiux-card text-center selectable anyone mb-3 ${selectedDomain === 'learning' ? 'active' : ''}`} data-title="learning" onClick={() => handleSelectableClick(setSelectedDomain, 'learning')}>
                                            <div className="card-body">
                                                <div className="avatar avatar-40 text-theme-1 fs-5 mb-2 rounded-circle">
                                                    <i className="bi bi-book"></i>
                                                </div>
                                                <p className="small text-secondary text-truncated">Learing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <h4>Best brand color<br />It create identity as well as trust.</h4>
                                <p className="text-secondary mb-3 mb-lg-4">Our template comes with Unlimited customized color scheme possibility. Here some color set are predefined to choose from.</p>
                                <div className="row gx-3" id="theme-select">
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-blue' ? 'active' : ''}`} data-title="theme-blue" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-blue')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-blue rounded"></span>
                                                <p className="text-secondary small d-none">Blue</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-indigo' ? 'active' : ''}`} data-title="theme-indigo" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-indigo')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-indigo rounded"></span>
                                                <p className="text-secondary small d-none">Indigo</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-purple' ? 'active' : ''}`} data-title="theme-purple" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-purple')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-purple rounded"></span>
                                                <p className="text-secondary small d-none">Purple</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-pink' ? 'active' : ''}`} data-title="theme-pink" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-pink')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-pink rounded"></span>
                                                <p className="text-secondary small d-none">Pink</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-red' ? 'active' : ''}`} data-title="theme-red" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-red')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-red rounded"></span>
                                                <p className="text-secondary small d-none">Red</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-orange' ? 'active' : ''}`} data-title="theme-orange" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-orange')}>
                                            <div className="card-body p-1">
                                                <div className="avatar avatar-40 rounded">
                                                    <span className="avatar avatar-40 bg-orange"></span>
                                                </div>
                                                <p className="text-secondary small d-none">Orange</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-yellow' ? 'active' : ''}`} data-title="theme-yellow" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-yellow')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-yellow rounded"></span>
                                                <p className="text-secondary small d-none">Yellow</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-green' ? 'active' : ''}`} data-title="theme-green" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-green')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-green rounded"></span>
                                                <p className="text-secondary small d-none">Green</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-teal' ? 'active' : ''}`} data-title="theme-teal" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-teal')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-teal rounded"></span>
                                                <p className="text-secondary small d-none">Teal</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto col-md-3 col-lg-2 col-xl-auto">
                                        <div className={`card adminuiux-card selectable anyone text-center mb-2 ${selectedTheme === 'theme-cyan' ? 'active' : ''}`} data-title="theme-cyan" onClick={() => handleSelectableClick(setSelectedTheme, 'theme-cyan')}>
                                            <div className="card-body p-1">
                                                <span className="avatar avatar-40 bg-cyan rounded"></span>
                                                <p className="text-secondary small d-none">Cyan</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 gx-lg-4 align-items-center mb-3 mb-lg-4">
                                    <div className="col-auto">
                                        <div className="avatar avatar-70 my-3 text-center rounded-circle bg-theme-1 p-1 coverimg">
                                            <img src={asset('assets/img/logo-512.png')} alt="" className="mw-100" id="companylogolight" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div>
                                            <label htmlFor="companylogo" className="form-label">Upload company logo </label><br />
                                            <input ref={companyLogoInputRef} className="form-control d-none" accept="image/*" type="file" id="companylogo" />
                                            <button className="btn btn-theme" onClick={() => companyLogoInputRef.current?.click()}><i className="bi bi-camera"></i> Upload</button>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        {/* content ends */}
                        <div className="row gx-3 gx-lg-4 justify-content-between">
                            <div className="col-auto">
                                <button className="btn btn-theme btn-square btn-prev"><i className="bi bi-arrow-left"></i></button>
                                <button
                                    className="btn btn-theme btn-square btn-next ms-1"
                                    onClick={() => {
                                        if (isLastSlide) {
                                            navigate('/auth/onboarding2');
                                        }
                                    }}
                                >
                                    <i className="bi bi-arrow-right"></i>
                                </button>
                            </div>
                            <div className="col-auto align-self-center">
                                <div className="swiper-pagination swiper-pagi line inline position-relative bottom-0"></div>
                            </div>
                            <div className="col-auto">
                                <Link to="/app/dashboard" className="btn btn-sm btn-link">Skip <i className="bi bi-arrow-right"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OnBoarding;
